module.exports = __webpack_public_path__ + "img/smz.e1d50a61.png";